<template>
  <div>
    <h1 class="titleprimary">
      <span class="titlecolorized">Inclus dans</span>
      <span class="titlenoncolorized"> Nos Offres</span>
    </h1>
    <div class="columns">
      <div class="column collingForFourColumn">
        <img
          class="imageClassforIntrod"
          src="../assets/imgused/prix-de-la-maison.png"
          alt="Generic placeholder image"
          width="140"
          height="140"
        />
        <h2 class="introClass">Valeur des biens</h2>
        <p>La possibilité de choisir la valeur de vos biens mobiliers</p>
      </div>
      <div class="column collingForFourColumn">
        <img
          class="imageClassforIntrod"
          src="../assets/imgused/fournitures.png"
          alt="Generic placeholder image"
          width="140"
          height="140"
        />
        <h2 class="introClass">Assurance scolaire</h2>
        <p>Protégez vos enfants en 1 clic</p>
      </div>
      <div class="column collingForFourColumn">
        <img
          class="imageClassforIntrod"
          src="../assets/imgused/fast-delivery.png"
          alt="Generic placeholder image"
          width="140"
          height="140"
        />
        <h2 class="introClass">Dépannage</h2>
        <p>
          La prise en charge des frais de déplacement d'un serrurier, plombier,
          vitrier...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroductionHabitation",
};
</script>